import { render } from "./DeleteProject.vue?vue&type=template&id=2742542a&scoped=true"
import script from "./DeleteProject.vue?vue&type=script&lang=js"
export * from "./DeleteProject.vue?vue&type=script&lang=js"

import "./DeleteProject.vue?vue&type=style&index=0&id=2742542a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2742542a"]])

export default __exports__